import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'

/**
 * Access control configuration for the Insights Portal Delivery Performance page.
 *
 * Requires:
 * - Permission: insights_portal_analytics.legacy_permission OR insights_portal_pickup_analytics.legacy_permission
 * - Entitlement: fulfillment.delivery_software.partner_bulk_delivery_enabled
 *
 * Replaces the previous Roulette gate (rt_insights_portal_delivery_dashboard) so retailer
 * access is governed by their contractual delivery software entitlement rather than a rollout flag.
 */
export const insightsPortalDeliveryDashboardAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.Analytics,
    featureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
  },
  {
    permissions: Permission.PickupAnalytics,
    featureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
  },
]
